import { render, staticRenderFns } from "./DisciplinesInterestHub.vue?vue&type=template&id=21ac6567"
import script from "./DisciplinesInterestHub.vue?vue&type=script&lang=js"
export * from "./DisciplinesInterestHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ac6567')) {
      api.createRecord('21ac6567', component.options)
    } else {
      api.reload('21ac6567', component.options)
    }
    module.hot.accept("./DisciplinesInterestHub.vue?vue&type=template&id=21ac6567", function () {
      api.rerender('21ac6567', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/DisciplinesInterestHub.vue"
export default component.exports